import { render } from "./animals_report.vue?vue&type=template&id=34a90115&scoped=true"
import script from "./animals_report.vue?vue&type=script&lang=js"
export * from "./animals_report.vue?vue&type=script&lang=js"

import "./animals_report.vue?vue&type=style&index=0&id=34a90115&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a90115"]])

export default __exports__